"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EDITOR_PLACEHOLDERS = exports.DETAILED_PLACEHOLDER_LIST = void 0;

var _ramda = require("ramda");

var DETAILED_PLACEHOLDER_LIST = {
  sender: [{
    placeholder: 'my-first-name',
    property: 'first_name',
    label: 'Sender first name'
  }, {
    placeholder: 'my-last-name',
    property: 'last_name',
    label: 'Sender last name'
  }, {
    placeholder: 'my-full-name',
    property: 'full_name',
    label: 'Sender full name'
  }, {
    placeholder: 'company',
    property: 'company',
    label: 'Sender company'
  }],
  recipient: [{
    placeholder: 'first-name',
    property: 'first_name',
    label: 'Contact first name'
  }, {
    placeholder: 'last-name',
    property: 'last_name',
    label: 'Contact last name'
  }, {
    placeholder: 'full-name',
    property: 'full_name',
    label: 'Contact full name'
  }, {
    placeholder: 'recipient-company',
    property: 'company',
    label: 'Contact company'
  }],
  gift: [{
    placeholder: 'gl',
    property: 'gl',
    label: 'Gift link'
  }],
  product: [{
    placeholder: 'gift-name',
    property: 'name',
    label: 'Gift name'
  }, {
    placeholder: 'product-brand',
    property: 'vendor_name',
    label: 'Product brand'
  }]
};
/**
 * @param {object} data
 * @param {string} data.placeholder
 * @param {string} data.label
 * @returns {{placeholder: string, label: string, value: string}}
 */

exports.DETAILED_PLACEHOLDER_LIST = DETAILED_PLACEHOLDER_LIST;

var transformPlaceholder = function transformPlaceholder(_ref) {
  var placeholder = _ref.placeholder,
      label = _ref.label;
  return {
    placeholder: placeholder,
    label: label,
    value: "[".concat(placeholder, "]")
  };
};

var getPlaceholderForEditor = (0, _ramda.pipe)(_ramda.values, _ramda.flatten, (0, _ramda.map)(transformPlaceholder));
var EDITOR_PLACEHOLDERS = getPlaceholderForEditor(DETAILED_PLACEHOLDER_LIST);
exports.EDITOR_PLACEHOLDERS = EDITOR_PLACEHOLDERS;